import axios from "./axios-auth";

const getClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclients",
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getClients api err", err);
        reject(err);
      });
  });

const getClientByID = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getclientbyid",
      method: "GET",
      params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getClientByID api err", err);
        reject(err);
      });
  });

const cloneClientAPI = (payload) =>
  new Promise((resolve, reject) => {
    console.log(payload);
    axios({
      url: "/dv-adm/cloneclient",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("cloneClientAPI api err", err);
        reject(err);
      });
  });

export { getClients, getClientByID, cloneClientAPI };
